import api from './api';

export const usersService = {
    // Obtener todos los usuarios
    getAll: async (params = {}) => {
        const { skip = 0, limit = 100 } = params;
        const response = await api.get(`/users/?skip=${skip}&limit=${limit}`);
        return response.data;
    },

    // Obtener usuario por ID
    getById: async (id) => {
        const response = await api.get(`/users/${id}`);
        return response.data;
    },

    // Actualizar usuario
    update: async (id, userData) => {
        const response = await api.put(`/users/${id}`, userData);
        return response.data;
    },

    // Eliminar usuario
    delete: async (id) => {
        const response = await api.delete(`/users/${id}`);
        return response.data;
    },

    // Subir imagen de firma (File object)
    uploadFirma: async (id, file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`/users/${id}/firma`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    // Eliminar firma
    deleteFirma: async (id) => {
        const response = await api.delete(`/users/${id}/firma`);
        return response.data;
    },
};